import * as TYPES from "../Profile/Profile.types";
import {getToken} from "../../../utils";

const profilePath = "teachers";

export const setupProfile = (formData, callback, errorCallback) => ({
    type: TYPES.SETUP_PROFILE,
    request: {
      method: "PATCH",
      url: `${profilePath}/profile-setup`,
      data: formData,
      headers: {
        authorization: getToken(),
        'Content-Type': 'multipart/form-data'
      },
    },
    callback,
    errorCallback,
})

export const getProfileInfo = (profileId, errorCallback) => ({
  type: TYPES.GET_PROFILE_INFO,
  request: {
    method: "GET",
    url: `${profilePath}/${profileId}`,
  },
  errorCallback
})

export const getSelfProfileInfo = (callback) => ({
  type: TYPES.GET_PROFILE_INFO,
  request: {
    method: "GET",
    url: `${profilePath}/self`,
    headers: {
      authorization: getToken(),
    },
  },
  callback
})

export const setupProfilePublicUrl = (publicUrlName, callback, errorCallback) => ({
  type: TYPES.SETUP_PROFILE_URL,
  request: {
    method: "PATCH",
    url: `${profilePath}/publicUrl`,
    data: {
      publicUrlName
    },
    headers: {
      authorization: getToken(),
    },
  },
  callback,
  errorCallback,
})

export const matchProfileUrl = (value, callback, errorCallback) => ({
  type: TYPES.MATCH,
  request: {
    method: "POST",
    url: `${profilePath}/matchProfileUrl`,
    data: { value : value },
  },
  callback,
  errorCallback
});

